import { RowGrid } from "@/components/Certifications";

import melloIcon from "@/assets/Projects/mello-icon.webp";
import rottoIcon from "@/assets/Projects/rotto.webp";
import pathiqIcon from "@/assets/Projects/pathiq-icon.png";

type App = {
  icon: string;
  name: string;
  status: string;
  href?: string;
};

export const apps: App[] = [
  {
    icon: melloIcon,
    name: "Mello",
    status: "Live on Play Store",
    href: "https://play.google.com/store/apps/details?id=com.chirag.mello",
  },
  {
    icon: rottoIcon,
    name: "Rotto",
    status: "Closed testing",
  },
  {
    icon: pathiqIcon,
    name: "PathIQ",
    status: "Closed testing",
    href: "https://pathsiq.vercel.app/",
  },
];

export function MobileApps() {
  return (
    <section
      id="mobile-apps"
      className="relative py-6 md:py-8 px-4 sm:px-6 bg-background overflow-hidden flex flex-col items-center"
    >
      <div className="site-frame relative z-10">
        <div className="mb-4 md:mb-5 text-left">
          <h2 className="text-[15px] md:text-base font-semibold tracking-tight text-foreground">
            Apps
          </h2>
        </div>

        <RowGrid items={apps.map((a) => ({ title: a.name, meta: a.status, logo: a.icon, url: a.href }))} />
      </div>
    </section>
  );
}
